import globalStore, { Flag } from "@/models/GlobalStore";

export interface OcostGpartOption {
    id: number;
    code: string;
    name: string;
    accCodeIn: string;
    accCodeOut: string;
    isCarSale: boolean;
    isPostCalc: boolean;
    isCarRectItem: boolean;
    isNewPostCalcType: boolean;
    isShcPostCalcType: boolean;
    isStockPostCalcType: boolean;
}

export default interface GpartOtherCostType {
    otherCostTypeId: number;
    otherCostTypeName: string;
    selectedOcostGpartId: number;
    options: OcostGpartOption[];
}

export const getFlags = (option: OcostGpartOption): Flag[] => {
    const flags = []
    if (option.isCarSale) flags.push(globalStore.flags.IsCarSale);
    if (option.isPostCalc) flags.push(globalStore.flags.IsPostCalc);
    if (option.isNewPostCalcType) flags.push(globalStore.flags.IsNewPostCalcType);
    if (option.isShcPostCalcType) flags.push(globalStore.flags.IsShcPostCalcType);
    if (option.isStockPostCalcType) flags.push(globalStore.flags.IsStockPostCalcType);
    if (option.isCarRectItem) flags.push(globalStore.flags.IsCarRectItem);
    return flags;
}